(function (Drupal) {
  function init(carousel) {
    (function () {
      const buttonsContainer = carousel.nextElementSibling;

      if (buttonsContainer) {
        var buttons = Array.from(
          buttonsContainer.querySelectorAll('button.carousel-nav__button'),
          function (button) {
            return button;
          }
        );
      }

      var items = Array.from(carousel.querySelectorAll('li.carousel__item'));

      if (buttons) {
        buttons.forEach(function (button, index) {
          var curryFunction = function (index) {
            var buttonNumber = index + 1;
            return function (e) {
              if (e.isTrusted === true) {
                var link_url, link_name;
                try {
                  link_name = items[index].querySelector('.field--name-field-title').innerText;
                  link_url = items[index].querySelector('a.btn').getAttribute('href');
                } catch (e) {
                }
                var dlvObject = {
                  'is_trusted': e.isTrusted,
                  'carousel_index': buttonNumber,
                  'event': 'gtm_carousel_clicked',
                };
                if (link_url) {
                  dlvObject.link_url = link_url;
                }
                if (link_name) {
                  dlvObject.link_name = link_name;
                }
                var dataLayer = window.dataLayer || [];
                dataLayer.push(dlvObject);
              }
            };
          };
          button.addEventListener('click', curryFunction(index));
        });
      }
    })();
  }

  Drupal.behaviors.stackCarouselGtm = {
    attach: function attach(context) {
      once('stack-carousel-gtm', '.carousel', context).forEach(init);
    },
  };
})(Drupal);
